// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"_2519H","isMobile":"_3h2ck"};